import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout/Layout";
import {
  useCancelAuditsMutation,
  useGetAuditsQuery,
} from "../../store/Api/audits";
import  {rowsPerPage} from '../../Utils/constant'
import { Link, useLocation, useNavigate } from "react-router-dom";
import { hidetoast, useDecodeToken } from "../../Utils/function";
import {
  useGetCentresQuery,
  useGetCityQuery,
  useGetRrbQuery,
  useGetStatesQuery,
} from "../../store/Api/common";
import { useGetUsersQuery } from "../../store/Api/users";
import ApiRoutes from "../../Utils/ApiRoutes";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { encrypt } from "../../Utils/crypto";
import AnnouncementsUi from "./AnnouncementsUi";
import { useAddAnnouncementMutation, useGetAnnouncementQuery } from "../../store/Api/announcement";
import * as Yup from "yup";
export const validationSchemaSe = Yup.object({
  title: Yup.string().trim().required("Please enter your Title"),
  description: Yup.string().trim().required("Please enter your Description"),
});
function Announcements() {
  const token = useSelector((state) => state.usertoken.token);
  const selectedCEN = useSelector((state) => state.cen.selectedCEN);
  const location = useLocation();
  const statusData = location?.state?.status;
  const navigate = useNavigate();
  const [showForm, setShowForm] = useState(false);
  const decodedToken = useDecodeToken();
  const [addAnnouncement] = useAddAnnouncementMutation();
 

  const [tableQaury, setTableQaury] = useState({
    search: "",
    rowsPerPage: rowsPerPage,
    currentPage: 1,
  });

  const { data, isFetching, isLoading, refetch } = useGetAnnouncementQuery({
    search: tableQaury.search,
    limit: tableQaury.rowsPerPage,
    page: tableQaury.currentPage,
  });

  const dispatch = useDispatch();
  const toast = useSelector((state) => state.toast);

  // Auto-hide toast after 3 seconds
  useEffect(() => {
    if (toast.message) {
      hidetoast();
    }
  }, [toast.message, dispatch]);

  const handlePageChange = (newPage) => {
    // setCurrentPage(newPage);
    setTableQaury({ ...tableQaury, currentPage: newPage });
  };
//   const handleSubmit = async (values, { resetForm }) => {
//     console.log(values, "values");

//     try {
//       const response = await addAnnouncement(values);
//       if (response?.data?.success) {
//         resetForm();
//         refetch()
//       }
//     } catch (error) {
//       console.log(error, "verify RRB error");
//     }
//   };
const handleSubmit = async (values) => {
    try {
      const response = await addAnnouncement(values);
      if (response?.data?.success) {
        refetch(); // Refresh data
        return response; // Return response for further use
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };
  const handleCloseModal = () => {
    setShowForm(false);
  };
const columns = [
    {
        title: "Date",
        dataKey: "createdAt",
        render: (createdAt) => {
          if (!createdAt) return "N/A";
          const date = new Date(createdAt);
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        },
      },
      {
        title: "Title",
        render: (_, row) =><p >{row?.title}</p>  || "N/A",
      },
      {
        title: "Description",
        render: (_, row) =><p className="mb-0" style={{width:"45vw"}}>{row?.description}</p>  || "N/A",
      },
    // { title: "Title", dataKey: "title" },
    // { title: "Description", dataKey: "Description" },
 
    // {
    //   title: "Actions",
    //   render: (_, row) =>
    //     row?.status == "pending" ? (
    //       "-"
    //     ) : (
    //       <div className="d-flex justify-content-end">
    //         {row?.status !== "inprogress" ? (
    //           <button
    //             className="border-0 bg-transparent"
    //             //   onClick={() => onView(row)}
    //           >
    //             <i class="fas fa-eye  color_blue_theame"></i>
    //           </button>
    //         ) : null}
    //         {row.status === "completed" &&
    //           Array.isArray(row.re_audit_requests) &&
    //           row.re_audit_requests[0]?.status === "approved" && (
    //             <button
    //               className="border-0 bg-transparent"
    //               //   onClick={() => onHistory(row)}
    //             >
    //               <i class="fas fa-history color_blue_theame"></i>
    //             </button>
    //           )}

    //         <button
    //           className="border-0 bg-transparent"
    //           type="button"
    //           //   onClick={() => setDeleteId(row?.id)}
    //           data-toggle="modal"
    //           data-target="#modal-danger"
    //         >
    //           <i class="text-danger fas fa-window-close"></i>
    //         </button>
    //       </div>
    //     ),
    // },
  ];

  return (
    <Layout>
      <AnnouncementsUi
        data={data?.data?.data || []}
        loading={isLoading}
        columns={columns}
        tableQaury={tableQaury}
        onPageChange={handlePageChange}
        totalRecords={data?.data?.totalItems} // Assuming the API returns a total count
        setTableQaury={setTableQaury}
        decodedToken={decodedToken}
        toast={toast}
        handleSubmit={handleSubmit}
        validationSchemaSe={validationSchemaSe}
        showForm={showForm}
        setShowForm={setShowForm}
        handleCloseModal={handleCloseModal}
      />
    </Layout>
  );
}

export default Announcements;
